import type { PendingOperation } from './offline';
import type { OfflineBatch } from './offlineAdapter';
export function pendingBirthEntries(operations: PendingOperation<OfflineBatch>[], episodeId: string) {
  return operations
    .filter((op) => op.envelope.payload.episodeId === episodeId)
    .flatMap((op) =>
      op.envelope.payload.inputs.map((input, index) => ({
        ...input,
        id: `${op.envelope.id}:${index}`,
        pendingState: op.state,
      })),
    );
}
export type PendingBirthEntry = ReturnType<typeof pendingBirthEntries>[number];
